import * as utils from "src/store/utils";
import { setImgStyle, parseImgUrlToken } from 'src/filter/modules/img.js'
const { setPrintArrayContent } = utils;
import { m60SizeMap } from '../simpleWoven/woven-config'
export function setInfo1(info, table1Size) {
	console.log(info, table1Size)
	if (!info || JSON.stringify(info) === JSON.stringify({})) return [];
	return {
		style: {
			fontSize: '3mm',
			flexDirection: "column",
			padding:'0 5mm'
		},
		children: [
			{
				children: [
					{
						style: {
							flexDirection: "column"
						},
						children: [
							{
								text: '款式图:',
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '5mm',
									width: '100%'
								}
							},
							{
								render(h) {
									const imgInfo = setImgStyle(info.frontBackImg, true)
									return <div style="width: 60mm;height:60mm;margin: 0 auto;line-height: 60mm;">
										<img src={parseImgUrlToken(imgInfo.url)} class={imgInfo.class} />
									</div>
								}
							}
						]
					},
					{
						style: {
							flexDirection: "column"
						},
						children: [
							{
								style: {
									textAlign: 'center',
									flex: 'none',
									height: '5mm',
									width: '100%'
								},
								textStyle: this.zoomStyle,
								text: `版型及缝制修改要求`
								
							},
							{
								text: `确认样衣版型及工艺修改:${info.confirmSamplePattern}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '20mm',
									width: '100%'
								}
							},
							{
								style: {
									flex: 'none',
									height: '10mm',
									width: '100%'
								},
								textStyle: this.zoomStyle,
								text: `样衣洗水效果:${info.sampleWashEffect}`
								
							},
							{
								text: `朴条&水晶条位置:${info.stripCrystalLocation}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '10mm',
									width: '100%'
								}
							},

							{
								text: `样衣面辅料及整体搭配效果确认:${info.suggestion}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '15mm',
									width: '100%'
								}
							},
							{
								text: `花稿位置:${info.draftPosition}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '5mm',
									width: '100%'
								}
							},
							{
								text: `确认板颜色:${info.boardColor}`,
								textStyle: this.zoomStyle,
								style: {
									flex: 'none',
									height: '5mm',
									width: '100%'
								}
							},
						]
					}
				]
			},
			{
				style: {
					flexDirection: "column",
					fontSize: '3mm'
				},
				children: setPage1Table(info, table1Size)
				// children: [

				// ]
			}
		]
	}
}

function setPage1Table(info, table1Size) {
	const isBrandCodeSix  = info.brandCode == '6'
		let itemStyleHeight;
	if (table1Size === 25) {
		itemStyleHeight = '7mm'
	}
	else if (table1Size === 35) {
		itemStyleHeight = '5mm'
	}
	else{
		itemStyleHeight = '4mm'
	}

	return setPrintArrayContent([
		{
			text: '部位',
			propsName: 'usedPosition',
			style: {
				height: '10mm'
			},
			itemStyle: {
				minHeight:itemStyleHeight,
				height: 'auto',
			}
		},
		{
			text: '度量方法(单位:CM)',
			propsName: 'degreeMethod',
			style: {
				height: '10mm',
				width: '65mm',
				flex: 'none'
			},
			itemStyle: {
				minHeight:itemStyleHeight,
				height: 'auto',
				width: '65mm',
				flex: 'none'
			}
		},
		...info.sizeCodeList.map(item => {
			return {
				render(h) {
					const has = m60SizeMap[item.sizeName];
					const isBrandSIXSizeCodeMap = {
						"XS": '欧洲XXS',
						"S": "欧洲XS",
						"M":"欧洲S",
						"L":"欧洲M",
						"XL":"欧洲L",
						"XXL":"欧洲XL",
						"XXXL":"欧洲XXL",
					}
					let  brandSixSizeName
					if(item.sizeName.indexOf('纸样尺寸') >-1 || item.sizeName.indexOf('样衣尺寸') >-1){
						brandSixSizeName = ''
					}else{
						brandSixSizeName = isBrandSIXSizeCodeMap[item.sizeName.replace(/[\u4e00-\u9fa5]/gm, '')]
					}
					return (!isBrandCodeSix ?<div>
						<p>{item.sizeName}</p>
						{has && <p>{has}</p>}
					</div>:<div style={{'line-height': '12px','text-align': 'center'}}>
						<p>{item.sizeName.replace(/[\u4e00-\u9fa5]/gm, '')}</p>
						<p>{item.sizeName.replace(/[^\u4e00-\u9fa5]/gm, '')}</p>
						{brandSixSizeName && <p>{brandSixSizeName}</p>}
					</div>)
				},
				// text: `item.sizeName`,
				propsName: item.sizeName,
				style: {
					height: '10mm'
				},
				itemStyle: {
					lineHeight: '13px',
					minHeight:itemStyleHeight,
					height: 'auto',
				}
			}
		}),
		{
			text: '公差',
			propsName: 'increaseOrDecrease',
			style: {
				height: '10mm'
			},
			itemStyle: {
				minHeight:itemStyleHeight,
				height: 'auto',
			}
		}
	], info.sizeItemList.map(item => {
		return {
			...item,
			...item.sizeMap
		}
	}), table1Size)
}

export function setInfo2(info, table2Size) {
	if (!info || JSON.stringify(info) === JSON.stringify({})) return [];
	return {
		style:{
			padding:'0 5mm'
		},
		children: [
			{
				style: {
					flexDirection: "column",
					height: '180mm',
					fontSize: '3mm',
				},
				children: setPage2Table(info, table2Size, this)
			},
			{
				style: {
					flexDirection: "column",
					height: '180mm',
				},
				children: [
					{
						text: `裁剪说明:${info.cuttingDescription}`,
						textStyle: this.zoomStyle,
						style: {
							width: '100%',
							height: '50mm',
							flex: 'none'
						},
					},
					{
						text: `风险评估:${info.riskAssessment}`,
						textStyle: this.zoomStyle,
						style: {
							width: '100%',
							height: '25mm',
							flex: 'none'
						},
					},
					{
						text: `特殊工艺:${info.specialProcessDescription}`,
						textStyle: this.zoomStyle,
						style: {
							width: '100%',
							height: '30mm',
							flex: 'none'
						},
					},
					{
						text: `缝制辅助说明:${info.sewingDescription}`,
						textStyle: this.zoomStyle,
						style: {
							width: '100%',
							height: '20mm',
							flex: 'none'
						},
					},
					{
						text: `后整要求:${info.packageDescription}`,
						textStyle: this.zoomStyle,
						style: {
							width: '100%',
							height: '20mm',
							flex: 'none'
						},
					},
					{
						text: `样衣数量说明:${info.sampleQuantityDescription}`,
						textStyle: this.zoomStyle,
					},
					{
						style: {
							width: '100%',
							height: '35mm',
							flex: 'none'
						},
						render(h) {
							const selectItem = info.detailItemList.find(item => item.usedPositionVal === '附加图片位置');
							if (!selectItem) return <div></div>
							const imgInfo = setImgStyle(selectItem.imgUrl, true)
							return <div>
								{/* <p style="width: 100%;height: 8mm;overflow: hidden;">{selectItem.methodRemark}</p> */}
								<div style="margin: 0 auto;width: 50mm;height: 50mm;line-height: 50mm;">
									<img src={imgInfo.url} class={imgInfo.class} />
								</div>
							</div>
						}
					}
				]
			}
		]
	}
}

function setPage2Table(info, table2Size, __this) {
	let itemHeight;
	console.log(itemHeight)
	if (table2Size === 7) {
		itemHeight = '40mm'
	}
	else if (table2Size === 10) {
		itemHeight = '30mm'
	}
	const _this = __this;
	return setPrintArrayContent(
		{
			children: [{
				text: '部位',
				textStyle: _this.zoomStyle,
				propsName: 'site',
				style: {
					height: '7mm',
					width: '15mm',
					flex: 'none'
				},
				itemStyle: {
					height: itemHeight,
					width: '15mm',
					flex: 'none'
				}
			},
			{
				text: '工艺说明',
				textStyle: _this.zoomStyle,
				propsName: 'methodRemark',
				style: {
					height: '7mm',
				},
				itemStyle: {
					height: itemHeight
				}
			}],
			style: {
				flex: 'none'
			}
		}, info.detailItemList.filter(item => Number(item.usedPosition) !== 3 && item.usedPositionVal !== '附加图片位置'), table2Size).concat([
			{
				style: {
					height: '50mm',
					flex: 'none',
					textAlign: 'center'
				},
				children: [
					{
						text: '唛头位置说明',
						textStyle: _this.zoomStyle,
						style: {
							flex: 'none',
							width: '15mm',

						}
					},
					{
						render(h) {
							const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 3);
							if (!selectItem) return <div></div>
							const imgInfo = setImgStyle(selectItem.imgUrl, true)
							return <div>
								{/* <p style="width: 100%;height: 8mm;overflow: hidden;">{selectItem.methodRemark}</p> */}
								<div style="margin: 0 auto;width: 50mm;height: 50mm;line-height: 50mm;">
									<img src={imgInfo.url} class={imgInfo.class} />
								</div>
							</div>

						}
					}
				]
			}
		])
}